// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre.tdv-value{margin-bottom:1px;overflow-wrap:anywhere}.number{color:#164}.string{color:#a11}", ""]);
// Exports
module.exports = exports;
